import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteUserImageAPI,
  fetchUserImagesAPI,
  uploadUserImagesAPI,
} from "./userImagesAPI";
import { showModal } from "../../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  uploadStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchUserImages = createAsyncThunk(
  "userImages/fetchImages",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchUserImagesAPI();
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const deleteUserImage = createAsyncThunk(
  "userImages/deleteUserImage",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteUserImageAPI(id);
      dispatch(
        showModal({
          message: `تم حذف الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete image"
      );
    }
  }
);

export const uploadUserImage = createAsyncThunk(
  "userImages/uploadUserImage",
  async (imageData, { dispatch, rejectWithValue }) => {
    try {
      const data = await uploadUserImagesAPI(imageData);
      dispatch(
        showModal({
          message: `تم رفع الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء رفع الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const userImagesSlice = createSlice({
  name: "userImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserImages.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchUserImages.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchUserImages.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(uploadUserImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadUserImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(uploadUserImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteUserImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(deleteUserImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteUserImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default userImagesSlice.reducer;
